import { Injectable } from '@angular/core';
import { LocationTypeModel } from '@bayclubs/group-classes-employee-api';


export interface SortableLocation {
    type: LocationTypeModel;
    name?: string | null;
    order: number;
}

@Injectable({
    providedIn: 'root'
})
export class LocationSortingService {
    constructor() {}
   
    public sortLocations(locations: SortableLocation[]) {
        const typeOrder: {[key: string]: number} = {
            'Court': 1,
            'Regular': 0
        };

        locations.sort((a,b) => {
            const ta = typeOrder[a.type];
            const tb = typeOrder[b.type];
            if(ta != tb) {
                return ta < tb ? -1 : 1;
            }

            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }

            return 0; 
        });

        locations.forEach((x, i) => {
            x.order = i;
        });
    }
}
